import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';

const LOGO_SRC = '/branding/cantir-logo.jpg';

/**
 * Schermata di caricamento (auth boot, Suspense, redirect).
 * Su Capacitor/Android segue lo splash nativo: stesso logo completo + spinner leggero.
 */
export function LoadingScreen() {
  return (
    <Box
      sx={{
        minHeight: '100dvh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 3,
        px: 3,
        bgcolor: '#F9FAF5',
      }}
    >
      <Box
        component="img"
        src={LOGO_SRC}
        alt="Cantir"
        sx={{
          width: 'min(280px, 78vw)',
          height: 'auto',
          display: 'block',
          userSelect: 'none',
        }}
      />
      <CircularProgress color="primary" size={28} thickness={4} />
      <Typography variant="body2" color="text.secondary">
        Caricamento…
      </Typography>
    </Box>
  );
}
